export default "__VITE_ASSET__Bo5AWrkI__"